export default "__VITE_ASSET__QpoAub28__"